import { Navigate, useLocation } from "react-router-dom";
import KariAsync from "../DocPages/KariAsync";
import KariPulse from "../DocPages/KariPulse";
import KariSequential from "../DocPages/KariSequential";
import KariUltrasonic from "../DocPages/KariUltrasonic";
import KariPIR from "../DocPages/KariPIR";
import KariBegin from "../DocPages/KariBegin";
import KariInfrared from "../DocPages/KariInfrared";
import KariUtility from "../DocPages/kariUtility";

const Sample = () => {
    const location = useLocation()
    const param = location.state || ""

    switch (param){
        case "kariAsync":
            return <KariAsync/>
        case "kariPulse":
            return <KariPulse/>
        case "kariSequential":
            return <KariSequential/>
        case "kariUltrasonic":
            return <KariUltrasonic/>
        case "kariBegin":
            return <KariBegin/>
        case "kariInfrared":
            return <KariInfrared/>
        case "kariPIR":
            return <KariPIR/>
        case "kariUtility":
            return <KariUtility/>
        default:
            return <Navigate to="/no-url" replace/>
    }
}

export default Sample;
